import { render, staticRenderFns } from "./NotAssinedStudents.vue?vue&type=template&id=533ab7af&"
import script from "./NotAssinedStudents.vue?vue&type=script&lang=js&"
export * from "./NotAssinedStudents.vue?vue&type=script&lang=js&"
import style0 from "./NotAssinedStudents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports